import { render, staticRenderFns } from "./CheckMark.vue?vue&type=template&id=1ef658e5&"
import script from "./CheckMark.vue?vue&type=script&lang=js&"
export * from "./CheckMark.vue?vue&type=script&lang=js&"
import style0 from "./CheckMark.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports